export const YOUR_GOOGLE_MAPS_API_KEY =
  "AIzaSyCBW2SpnMWfoB1hN3Z9CgIPiwBOUbxjzwg";
